<template>
  <div>
    <header-component />
    <b-container fluid>
      <b-row>
        <b-col cols="12" sm="12" md="4" lg="4" class="left_side">
          <div class="steps">
            <h4>RAJ5 Online Application</h4>
            <p>Get your cash right away upon approval</p>

            <div class="prog_bar relative">
              <b-progress :value="value" :max="max" animated height="40px"></b-progress>
              <p>{{currentRouteName}} of 7 to get ₱ 10 000.00</p>
            </div>
            <p>Max amount for the 1st loan is ₱ 10 000.00</p>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="8" lg="8" class="right_side">
          <b-form>
            <router-view></router-view>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
    <footer-component />
  </div>
</template>

<script>
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer2.vue";

export default {
  data() {
    return {
      value: 1,
      max: 7
    };
  },
  components: {
    headerComponent,
    footerComponent
  },
  computed: {
    currentRouteName() {
      if (this.$route.name === "ID Upload") {
        return "Step 6";
      } else {
        return this.$route.name;
      }
    }
  },
  methods: {
    progressBar() {
      if(this.currentRouteName) {
        this.value = parseFloat(this.currentRouteName.match(/\d/g)[0]) - 1 ;
      }
    }
  },
  beforeMount() {
    window.scrollTo(0, 0);
  },
  mounted () {
    this.progressBar();
  },
  beforeUpdate () {
    this.progressBar();
  }
};
</script>

<style lang="scss" scoped>
.left_side {
  padding: 60px 40px;
  background: $base-color-blue;
  .steps {
    color: #fff;
    .prog_bar {
      position: relative;
      margin-bottom: 15px;
      p {
        margin-bottom: 0;
        color: #434343;
        position: absolute;
        top: 8px;
        left: 0;
        right: 0;
        text-align: center;
        margin: 0 auto;
        z-index: 3;
        text-shadow: 2px 2px 4px #ffffff, 2px 2px 7px #ffffff,
          2px 2px 11px #ffffff, 5px 5px 15px #ffffff, 5px -5px 15px #ffffff,
          5px -5px 15px #ffffff;
      }
    }
  }
}
.right_side {
  padding: 60px 40px;
  background: $bg-lightgray;
}
</style>
<style lang="scss">
.right_side {
  form {
    .form-group {
      margin-bottom: 20px;
      input {
        height: 50px;
      }
    }
    select {
      margin-bottom: 20px;
      height: 50px !important;
    }
    .custom-checkbox {
      margin-bottom: 20px;
    }
    .next {
      button {
        color: #fff;
        background: $base-color-blue;
        border: 0;
        border-radius: 4px;
        padding: 5px 20px;
        height: 50px;
      }
      a {
        color: #fff;
        background: $base-color-blue;
        border: 0;
        border-radius: 4px;
        padding: 5px 20px;
        height: 50px;
        line-height: 40px;
        text-decoration: none;
      }
      button:disabled,
      button[disabled] {
        opacity: .5;
      }
    }
  }
}

@media (max-width: 480px) {
  .row {
    .left_side {
      padding: 60px 15px;
    }
    .right_side {
      padding: 60px 15px;
    }
  }
}
</style>